import react from "react";

export const KpiCard = ({ label, value, subLabel, icon: Icon, onClick }) => (
  <div onClick={onClick} className="bg-white/95 rounded-2xl shadow-sm hover:shadow-md transition-shadow p-4 border border-slate-100/80 flex flex-col justify-between">
    <div className="flex items-center justify-between gap-2">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
        {label}
      </p>
      {Icon && (
        <div className="p-1.5 rounded-xl bg-blue-50 text-blue-600 border border-blue-100">
          <Icon className="w-4 h-4" />
        </div>
      )}
    </div>
    <div className="mt-2 text-2xl font-bold text-blue-700">{value}</div>
    {subLabel && (
      <p className="mt-1 text-xs text-slate-500 truncate">{subLabel}</p>
    )}
  </div>
);